import React, { memo, forwardRef } from "react";
const SvgCapitalTheta = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M12.296 16.624v-1.872h7.248v1.872h-7.248zm11.52-.816c0 1.328-.168 2.536-.504 3.624-.336 1.072-.84 2-1.512 2.784a6.385 6.385 0 01-2.472 1.8c-.976.416-2.112.624-3.408.624-1.344 0-2.512-.208-3.504-.624-.992-.432-1.816-1.032-2.472-1.8-.656-.784-1.144-1.72-1.464-2.808C8.16 18.32 8 17.112 8 15.784c0-1.76.288-3.296.864-4.608.576-1.312 1.448-2.336 2.616-3.072C12.664 7.368 14.152 7 15.944 7c1.712 0 3.152.368 4.32 1.104 1.168.72 2.048 1.744 2.64 3.072.608 1.312.912 2.856.912 4.632zm-13.536 0c0 1.44.2 2.68.6 3.72.4 1.04 1.016 1.84 1.848 2.4.848.56 1.912.84 3.192.84 1.296 0 2.352-.28 3.168-.84.832-.56 1.448-1.36 1.848-2.4.4-1.04.6-2.28.6-3.72 0-2.16-.448-3.848-1.344-5.064-.896-1.232-2.312-1.848-4.248-1.848-1.296 0-2.368.28-3.216.84-.832.544-1.448 1.336-1.848 2.376-.4 1.024-.6 2.256-.6 3.696z"
      />
    </svg>
  );
});
SvgCapitalTheta.displayName = "SvgCapitalTheta";
const MemoForwardRef = memo(SvgCapitalTheta);
export default MemoForwardRef;
